export default __webpack_public_path__ + "static/media/f_helmet.fdfef8c1.svg";